{
  "REPORT": {
    "HEADER": "Conversations",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_AGENT_REPORTS": "Download agent reports",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Messages received",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Messages sent",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Total )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Danes",
      "YESTERDAY": "Včeraj",
      "LAST_7_DAYS": "Last 7 days",
      "LAST_30_DAYS": "Last 30 days",
      "THIS_MONTH": "Ta mesec",
      "LAST_MONTH": "Prejšnji mesec",
      "LAST_3_MONTHS": "Last 3 months",
      "LAST_6_MONTHS": "Last 6 months",
      "LAST_YEAR": "Last year",
      "CUSTOM_DATE_RANGE": "Custom date range"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Group By",
    "DURATION_FILTER_LABEL": "Duration",
    "GROUPING_OPTIONS": {
      "DAY": "Day",
      "WEEK": "Week",
      "MONTH": "Month",
      "YEAR": "Year"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      },
      {
        "id": 4,
        "groupBy": "Year"
      }
    ],
    "BUSINESS_HOURS": "Business Hours",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "No results found"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Pogovori: {count}",
      "RESULT_COUNT_MESSAGE": "Sporočila: {count}",
      "EMPTY": "Za ta stolpec ni zapisov.",
      "ERROR": "Zapisov ni bilo mogoče naložiti. Poskusite znova.",
      "LOAD_MORE": "Naloži več",
      "PREVIOUS_BUCKET": "Prejšnji stolpec",
      "NEXT_BUCKET": "Naslednji stolpec",
      "UNKNOWN_CONTACT": "Neznan stik",
      "UNKNOWN_INBOX": "Neznan nabiralnik",
      "UNASSIGNED_AGENT": "Nedodeljeno",
      "NO_MESSAGE_CONTENT": "Sporočilo nima vsebine",
      "MESSAGE_CREATED_AT": "Sporočilo ustvarjeno {time}",
      "EVENT_OCCURRED_AT": "Dogodek se je zgodil {time}",
      "INCOMING_MESSAGE": "Dohodno sporočilo",
      "OUTGOING_MESSAGE": "Odhodno sporočilo",
      "VIEW_ALL": "Prikaži v pogovorih",
      "VIEW_ALL_LIMIT": "Na seznamu pogovorov se odprejo samo stolpci z največ {limit} pogovori.",
      "HIDDEN_COUNT": "Ni prikazano, ker niste član njihovega nabiralnika: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Agents Overview",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_AGENT_REPORTS": "Download agent reports",
    "FILTER_DROPDOWN_LABEL": "Select Agent",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Labels Overview",
    "DESCRIPTION": "Spremljajte uspešnost oznak s ključnimi metrikami, vključno s pogovori, odzivnimi časi, časi reševanja in rešenimi primeri.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_LABEL_REPORTS": "Download label reports",
    "FILTER_DROPDOWN_LABEL": "Select Label",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Inbox Overview",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_INBOX_REPORTS": "Download inbox reports",
    "FILTER_DROPDOWN_LABEL": "Select Inbox",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Team Overview",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_TEAM_REPORTS": "Download team reports",
    "FILTER_DROPDOWN_LABEL": "Select Team",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Reports",
    "NO_RECORDS": "There are no CSAT survey responses available.",
    "DOWNLOAD": "Download CSAT Reports",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Choose Agents"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contact",
        "AGENT_NAME": "Assigned agent",
        "RATING": "Rating",
        "FEEDBACK_TEXT": "Feedback comment"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Total responses",
        "TOOLTIP": "Total number of responses collected"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Satisfaction score",
        "TOOLTIP": "Total number of positive responses / Total number of responses * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Response rate",
        "TOOLTIP": "Total number of responses / Total number of CSAT survey messages sent * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Število pogovorov",
        "TOOLTIP": "Skupno število pogovorov s sporočili bota"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Število odgovorov",
        "TOOLTIP": "Skupno število odhodnih sporočil"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Število odgovorov UI",
        "TOOLTIP": "Skupno število odgovorov, ki jih je poslal bot"
      },
      "COPILOT_COUNT": {
        "LABEL": "Število pripravljenih odgovorov",
        "TOOLTIP": "Skupno število predlogov copilota, ki jih je bot pripravil za agente"
      },
      "SUCCESS_RATE": {
        "LABEL": "Rešil UI",
        "TOOLTIP": "Odstotek pogovorov, ki jih je rešil UI brez predaje agentu"
      },
      "RESOLVE_TIME": {
        "LABEL": "Čas rešitve",
        "TOOLTIP": "Mediana časa od prvega sporočila stranke do zadnjega sporočila bota/agenta"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Ne združuj",
      "INBOXES": "Nabiralniki",
      "LABELS": "Oznake"
    },
    "GROUPED": {
      "CHART_TITLE": "Porazdelitev po skupinah",
      "BACK_TO_ALL": "Prikaži vse",
      "TABLE": {
        "INBOX": "Nabiralnik",
        "LABEL": "Oznaka",
        "CONVERSATIONS": "Pogovori",
        "MESSAGES": "Sporočila",
        "MESSAGES_TOOLTIP": "Skupno število odhodnih sporočil",
        "AI_MESSAGES": "Odgovori UI",
        "AI_MESSAGES_TOOLTIP": "Skupno število odgovorov UI, sledi število pozitivnih in negativnih ocen uporabnikov",
        "THUMBS_UP_TOOLTIP": "Število odgovorov UI, ki so jih uporabniki ocenili pozitivno (palec gor)",
        "THUMBS_DOWN_TOOLTIP": "Število odgovorov UI, ki so jih uporabniki ocenili negativno (palec dol)",
        "PREPARED": "Pripravljeni odgovori",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Odstotek sporočil od vseh sporočil, ki pripadajo tej skupini",
        "BOT_RESPONSES": "Odgovori UI %",
        "SUGGESTION_USED": "Uporabljeni odgovori",
        "SUGGESTION_USED_TOOLTIP": "Odstotek pripravljenih odgovorov v tej skupini, ki so jih uporabili agenti",
        "SUGGESTION_NOT_USED": "Neuporabljeni odgovori",
        "SUGGESTION_NOT_USED_TOOLTIP": "Odstotek sporočil v tej skupini, ki so imela pripravljen odgovor, a ta ni bil uporabljen"
      },
      "NOTES": {
        "TITLE": "Kako se izračunajo metrike",
        "CONVERSATIONS": "Število pogovorov z vsaj enim odhodnim sporočilom v izbranem obdobju.",
        "MESSAGES": "Skupno število odhodnih (nezasebnih) sporočil, poslanih v izbranem obdobju. To vključuje sporočila, ki jih je ustvaril UI, in sporočila, ki so jih napisali ljudje.",
        "PERCENTAGE": "Delež sporočil te skupine od vseh odhodnih sporočil v vseh skupinah.",
        "AI_MESSAGES": "Število odhodnih sporočil, ki jih je samodejno poslal bot UI (brez pripravljenih odgovorov za agente). Številki v oklepaju prikazujeta, koliko od teh odgovorov so uporabniki ocenili pozitivno (palec gor) in negativno (palec dol).",
        "PREPARED": "Število predlogov copilota (pripravljenih odgovorov), ki jih je bot UI ustvaril za agente v izbranem obdobju. To so zasebna sporočila, vidna samo agentom, in se ne štejejo kot odhodna sporočila, zato to število morda ne ustreza stolpcu Sporočila.",
        "SUGGESTION_USED": "Odstotek pripravljenih odgovorov v tej skupini, ki so jih uporabili agenti. To morda ne ustreza številu pripravljenih odgovorov, ker lahko vključuje tudi predloge, ustvarjene v prejšnjih obdobjih.",
        "SUGGESTION_NOT_USED": "Odstotek odhodnih sporočil v tej skupini, pri katerih je bil na voljo predlog copilota, agent pa je odgovoril brez njegove uporabe. Šteje se samo, kadar je agent dejansko poslal odgovor. To morda ne ustreza številu pripravljenih odgovorov, ker lahko vključuje tudi predloge, ustvarjene v prejšnjih obdobjih."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Overview",
    "LIVE": "Live",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Open Conversations",
      "LOADING_MESSAGE": "Loading conversation metrics...",
      "OPEN": "Open",
      "UNATTENDED": "Unattended",
      "UNASSIGNED": "Unassigned",
      "PENDING": "Pending"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversations by agents",
      "LOADING_MESSAGE": "Loading agent metrics...",
      "NO_AGENTS": "There are no conversations by agents",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Open",
        "UNATTENDED": "Unattended",
        "STATUS": "Status"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Ekipa",
        "OPEN": "Open",
        "UNATTENDED": "Unattended",
        "STATUS": "Status"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agent status",
      "ONLINE": "Online",
      "BUSY": "Busy",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Dodaj filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "No results found",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Ime agenta",
        "INBOXES": "Ime nabiralnika",
        "LABELS": "Label name",
        "TEAMS": "Team name"
      },
      "SLA": "Politika SLA",
      "INBOXES": "Inbox",
      "AGENTS": "Agent",
      "LABELS": "Label",
      "TEAMS": "Team"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Conversation",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Vmesni seštevek",
    "NO_TEAM": "Brez ekipe",
    "GROUP_BY_TEAMS": "Združi po ekipah",
    "INBOX": "Nabiralnik",
    "AGENT": "Agent",
    "TEAM": "Ekipa",
    "LABEL": "Oznaka",
    "TOTAL": "Skupaj",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Število razrešitev",
    "CONVERSATIONS": "Število pogovorov",
    "OUTGOING_CHATS": "Odhodni klepeti",
    "OUTGOING_EMAILS": "Odhodna e-pošta",
    "PHONE_CALLS": "Telefonski klici",
    "INBOUND_CALLS": "Dohodni klici",
    "OUTBOUND_CALLS": "Odhodni klici",
    "TOTAL_ACTIVITIES": "Skupne dejavnosti",
    "ONLINE_TIME": "Čas na spletu",
    "QUEUE_AVAILABLE_TIME": "Čas razpoložljivosti v čakalni vrsti",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Število odhodnih sporočil, ki jih je poslal ta agent",
      "OUTGOING_EMAILS": "Število odhodnih e-poštnih sporočil, ki jih je poslal ta agent",
      "PHONE_CALLS": "Skupno število telefonskih klicev, dodeljenih temu agentu (vsota dohodnih in odhodnih klicev)",
      "TOTAL_ACTIVITIES": "Skupno število dejavnosti: dohodni klici + odhodni klici + odhodni klepeti + odhodna e-pošta",
      "INBOUND_CALLS": "Število dohodnih telefonskih klicev, dodeljenih temu agentu",
      "OUTBOUND_CALLS": "Število odhodnih telefonskih klicev, dodeljenih temu agentu",
      "AVG_FIRST_RESPONSE_TIME": "Povprečni čas od ustvarjenja pogovora do prvega odziva agenta v pogovorih, dodeljenih temu agentu",
      "AVG_RESOLUTION_TIME": "Povprečni čas od ustvarjenja pogovora do rešitve v pogovorih, dodeljenih temu agentu",
      "AVG_REPLY_TIME": "Povprečni čas, ki ga stranke čakajo med svojim sporočilom in odgovorom agenta v pogovorih, dodeljenih temu agentu",
      "ONLINE_TIME": "Skupni čas, ko je bil agent na spletu ali zaseden v izbranem obdobju",
      "QUEUE_AVAILABLE_TIME": "Skupni čas, ko je bil agent na voljo v telefonskih čakalnih vrstah v izbranem obdobju"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Telefonska poročila",
    "DESCRIPTION": "Spremljajte metrike telefonskih klicev s podrobnim vpogledom v dohodne in odhodne klice, združene po agentu ali nabiralniku za celovito analizo.",
    "DOWNLOAD_PHONE_REPORTS": "Prenesi telefonska poročila",
    "GROUP_BY": {
      "LABEL": "Združi po",
      "AGENT": "Agent",
      "INBOX": "Nabiralnik"
    },
    "TABLE": {
      "TOTAL_CALLS": "Skupaj",
      "INBOUND_CALLS": "Dohodni",
      "OUTBOUND_CALLS": "Odhodni",
      "FAILED_OUTBOUND_CALLS": "Neuspešni odhodni",
      "AVG_AGENT_HANDLED_DURATION": "Povp. trajanje",
      "TOTAL_AGENT_HANDLED_DURATION": "Skupno trajanje",
      "AVG_RINGING_TIME": "Povp. čas zvonjenja",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Uspešnost %",
      "UNIQUE_CALLERS": "Edinstveni klicatelji",
      "UNIQUE_CALLED_CONTACTS": "Edinstveni poklicani",
      "UNANSWERED_MISSED_CALLS": "Zgrešeni brez nadaljnjega klica",
      "UNANSWERED_MISSED_PERCENTAGE": "Neodgovorjeni zgrešeni %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Zgrešeni brez nadaljnjega klica, premalokrat poklicani nazaj",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Zgrešeni brez nadaljnjega klica, premalokrat poklicani nazaj %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Skupno število vseh klicev (vključno z nepovezanimi)",
      "INBOUND_CALLS": "Število povezanih klicev",
      "OUTBOUND_CALLS": "Število vseh odhodnih klicev (vključno z nepovezanimi)",
      "FAILED_OUTBOUND_CALLS": "Število odhodnih klicev, ki niso bili povezani",
      "AVG_AGENT_HANDLED_DURATION": "Povprečno trajanje klicev, ki so jih obravnavali agenti",
      "TOTAL_AGENT_HANDLED_DURATION": "Skupno trajanje vseh klicev, ki so jih obravnavali agenti",
      "AVG_RINGING_TIME": "Povprečni čas zvonjenja klicev, preden je bilo odgovorjeno",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Odstotek odhodnih klicev, ki so bili uspešno povezani",
      "UNIQUE_CALLERS": "Število edinstvenih kontaktov, ki so opravili dohodne klice",
      "UNIQUE_CALLED_CONTACTS": "Število edinstvenih kontaktov, ki so bili poklicani prek odhodnih klicev",
      "UNANSWERED_MISSED_CALLS": "Število zgrešenih klicev, pri katerih ni bilo uspešnega povratnega klica (povezan klic). Lahko vključuje klice, ki jih je še mogoče obravnavati v poslovnem dnevu",
      "UNANSWERED_MISSED_PERCENTAGE": "Odstotek edinstvenih klicateljev, katerih klici so bili zgrešeni brez nadaljnjega klica (neodgovorjeni zgrešeni klici / edinstveni klicatelji)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Število zgrešenih klicev z manj kot 2 poskusoma povratnega klica. Lahko vključuje klice, ki jih je še mogoče obravnavati v poslovnem dnevu",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Odstotek edinstvenih klicateljev z manj kot 2 poskusoma povratnega klica ((zgrešeni brez nadaljnjega klica – zadostno obravnavani) / edinstveni klicatelji)"
    }
  }
}
